import React, {useEffect, useState} from 'react';
import './scss/contract-add.scss';
import ContractProp from './properties/contract';
import CollectionDetailsModel from '../models/collection-details';
import FullScreenLoader from './full-screen';
import SandraJsAPI from "../services/sandraJsAPI";
import {StatusMessageTypeEnum} from "../enums/StatusMessageTypeEnum";

function ContractAdd(contractProp: ContractProp): React.ReactElement {
    const {collectionId, setStatusMessage} = contractProp;

    const collectionDetailsInit: CollectionDetailsModel = {
        collection: {
            collectionId: '',
            creationTimestamp: new Date(),
            description: '',
            image: '',
            name: '',
            imageUrl: '',
        },
        contracts: [],
    };

    const [collectionDetails, setCollectionDetails] = useState(collectionDetailsInit);

    const [address, setAddress] = useState('');
    const [standard, setStandard] = useState({selected: ''});
    const [metadataType, setMetadataType] = useState({selected: ''});
    const [blockChain, setBlockchain] = useState({selected: ''});
    const [isLoading, setIsLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState('');
    const [errorClass, setSetErrorClass] = useState('hide');

    function resetForm() {
        setAddress('');
        setBlockchain({selected: ''});
        setStandard({selected: ''});
        setMetadataType({selected: ''});
    }

    function validateForm() {
        if (!blockChain.selected) {
            setErrorMessage('Please select blockchain value');
            setSetErrorClass('error mb-4');
            return false;
        }

        if (!address.trim()) {
            setErrorMessage('Please enter address');
            setSetErrorClass('error mb-4');
            return false;
        }

        if (!standard.selected) {
            setErrorMessage('Please select standard value');
            setSetErrorClass('error mb-4');
            return false;
        }

        if (!metadataType.selected) {
            setErrorMessage('Please select metadata type');
            setSetErrorClass('error mb-4');
            return false;
        }

        setErrorMessage('');
        setSetErrorClass('hide');
        return true;
    }

    const handleSubmit = (event: any) => {
        event.preventDefault();
        if (validateForm()) {
            setIsLoading(true);
            SandraJsAPI.addContract({
                address: address.trim().toLowerCase(),
                blockchain: blockChain.selected.toLowerCase(),
                standard: standard.selected.toLowerCase(),
                collections: [],
                token: {
                    tokenId: '',
                    tokenUrl: '',
                },
                assetKeyId: '',
                baseTokenUrl: '',
                metadataType: metadataType.selected
            }, collectionDetails.collection)
                .then((res) => {
                    console.log(res);
                    setIsLoading(false);
                    setStatusMessage('Address added successfully', StatusMessageTypeEnum.success);
                    window.scrollTo(0, 0);
                    resetForm();
                })
                .catch((reason) => {
                    console.log(reason);
                    setIsLoading(false);
                    window.scrollTo(0, 0);
                    setStatusMessage(reason, StatusMessageTypeEnum.error);
                });
        } else {
            window.scrollTo(0, 0);
        }
    };

    useEffect(() => {
        SandraJsAPI.getCollectionDetailsAsync((collectionId))
            .then((result) => {
                setCollectionDetails(result.data);
                setIsLoading(false);
            })
            .catch((reason) => {
                console.log(reason);
                setIsLoading(false);
            });
    }, []);

    return (
        <div className="rounded contract-add loading-wrapper">
            {isLoading ? <FullScreenLoader/> : <div/>}
            <h4 className="pb-3">Add New Contract</h4>
            <form onSubmit={handleSubmit}>
                <div className={errorClass}>{errorMessage}</div>
                <div className="mb-3 clearfix pb-2 image-box">
                    <a href={`/collection?id=${collectionDetails?.collection?.collectionId}`} className="text-center">
                        <img
                            alt={collectionDetails?.collection?.name}
                            src={collectionDetails?.collection?.imageUrl}
                            className="rounded-circle"
                        />
                        <div className="ps-4 content-area">
                            <h6 className="title">
                                {collectionDetails?.collection?.name}
                            </h6>
                            <div className="text-sm-light desc ">
                                {collectionDetails?.collection?.description}
                            </div>
                            <div className="text-sm-light desc fst-italic " style={{fontSize: '12px'}}>
                                (Collection)
                            </div>
                        </div>
                    </a>
                </div>

                <div className="mb-3">
                    <select
                        aria-label="Select Blockchain"
                        onChange={(e) => setBlockchain({selected: e.target.value})}
                        className="form-select"
                        value={blockChain.selected}
                    >
                        <option value="">Select Blockchain</option>
                        <option value="binance">Binance</option>
                        <option value="ethereum">Ethereum</option>
                        <option value="klaytn">Klaytn</option>
                        <option value="ordinal">Ordinal</option>
                    </select>
                </div>

                <div className="mb-3">
                    <label htmlFor="address" className="form-label">
                        Address
                        <input
                            type="text"
                            id="address"
                            className="form-control"
                            value={address}
                            onChange={(e) => setAddress(e.target.value)}
                        />
                    </label>
                </div>

                <div className="mb-3">
                    <select
                        aria-label="Select Standard"
                        onChange={(e) => setStandard({selected: e.target.value})}
                        className="form-select"
                        value={standard.selected}
                    >
                        <option value="">Select Standard</option>
                        <option value="erc721">ERC721</option>
                        <option value="erc1155">ERC1155</option>
                        <option value="ord">Ordinal</option>
                    </select>
                </div>

                <div className="mb-3">
                    <select
                        aria-label="Select Metadata Type"
                        onChange={(e) => setMetadataType({selected: e.target.value})}
                        className="form-select"
                        value={metadataType.selected}
                    >
                        <option value="">Select Metadata Type</option>
                        <option value="http">Http</option>
                        <option value="ipfs">IPFS</option>
                        <option value="inTokenUrl">Metadata in token url</option>
                    </select>
                </div>
                <button type="submit" className="btn btn-dark">Submit</button>
            </form>
        </div>
    );
}

export default ContractAdd;
